/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComponentTypes, LifecycleHooks, registerGlobalHook } from '@tinijs/core';
import { TINI_APP_CONTEXT, ROUTE_CHANGE_EVENT } from './consts';
import { hideNavIndicator, showNavIndicator } from './methods';
import { Router } from './router';
export function createRouter(routes, options = {}) {
    var _a;
    const router = new Router(routes, options).init();
    // handle nav indicator
    if ((_a = TINI_APP_CONTEXT.options) === null || _a === void 0 ? void 0 : _a.navIndicator) {
        router.indicatorSchedule = null;
        // exit
        registerGlobalHook(ComponentTypes.Page, LifecycleHooks.OnChildrenReady, () => {
            if (router.indicatorSchedule === null)
                return;
            hideNavIndicator();
            // cancel schedule (if scheduled)
            clearTimeout(router.indicatorSchedule);
            router.indicatorSchedule = null;
        });
        // entry
        addEventListener(ROUTE_CHANGE_EVENT, e => {
            const { url } = e.detail;
            if (url.pathname === location.pathname)
                return;
            router.indicatorSchedule = setTimeout(() => showNavIndicator(), 500);
        });
    }
    // result
    return (TINI_APP_CONTEXT.router = router);
}
//# sourceMappingURL=main.js.map